/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespRefineMenuDrawerHeader_itemSearch = {
    readonly clearAppliedFiltersLinkReference: string | null;
    readonly appliedFilters: ReadonlyArray<{
        readonly canBeDismissed: boolean | null;
    } | null> | null;
    readonly " $refType": "SbRespRefineMenuDrawerHeader_itemSearch";
};
export type SbRespRefineMenuDrawerHeader_itemSearch$data = SbRespRefineMenuDrawerHeader_itemSearch;
export type SbRespRefineMenuDrawerHeader_itemSearch$key = {
    readonly " $data"?: SbRespRefineMenuDrawerHeader_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespRefineMenuDrawerHeader_itemSearch">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespRefineMenuDrawerHeader_itemSearch",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "clearAppliedFiltersLinkReference",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SearchBrowseParsedParam",
      "kind": "LinkedField",
      "name": "appliedFilters",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "canBeDismissed",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};
(node as any).hash = '0c7d37dbacccb275c6b73ecb4d5a33a5';
export default node;
